import React from "react";
import { DocumentTextIcon } from "@heroicons/react/24/outline";

export const TreatmentInfoBanner = () => {
  return (
    <div className="relative">
      <div className="px-6 sm:px-8 lg:px-12">
        <div className="relative mx-auto">
          <div
            className="relative bg-white dark:bg-gray-800/60 rounded-2xl shadow-sm border border-gray-200/60 dark:border-gray-700/40 p-8 sm:p-10"
          >
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 sm:gap-8">
              <div className="flex-shrink-0">
                <div className="p-3.5 rounded-xl bg-ergo-50 dark:bg-ergo-900/60">
                  <DocumentTextIcon className="h-6 w-6 text-ergo-600 dark:text-ergo-400" />
                </div>
              </div>
              <div>
                <p className="text-base text-gray-600 dark:text-gray-300 leading-relaxed">
                  Voraussetzung für eine ergotherapeutische Behandlung als Kassenleistung ist eine Verordnung von ihrer
                  behandelnden Ärztin oder ihrem Arzt. Zusätzlich bieten wir zahlreiche ergänzende und präventive
                  Leistungen auf Selbstzahlerbasis an.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
